import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCartIcon, ArrowRightIcon } from 'lucide-react';
import { PageShell } from '../components/layout/PageShell';
import { DrinkRow } from '../components/order/DrinkRow';
import { Button } from '../components/ui/Button';
import { SmartImage } from '../components/common/SmartImage';
import { useI18n } from '../lib/i18n';
import { useCart } from '../lib/cart';
import { DRINKS, MACHINE } from '../lib/data';
import { IMAGES } from '../lib/images';
export function Select() {
  const {
    t,
    lang
  } = useI18n();
  const navigate = useNavigate();
  const {
    machineId
  } = useParams();
  const {
    typeCount,
    totalQty,
    total
  } = useCart();
  const id = machineId ?? MACHINE.id;
  return <PageShell data-id="element-396" data-mp="16ex3k8ns50xa">
      <section className="mx-auto max-w-2xl px-4 pb-40 pt-8 sm:px-6" data-id="element-397" data-mp="16en9o9zm69mb">
        <div className="glass-card mb-6 flex items-center gap-4 p-4" data-id="element-398" data-mp="11gltpxxhiqf2">
          <SmartImage src={IMAGES.machinePhoto} alt="RevoV machine" className="h-16 w-16 rounded-lg object-cover" data-id="element-399" data-mp="11e93kxhkp9qx" />
          <div data-id="element-400" data-mp="3ov625ss3l5rd">
            <h1 className="text-2xl font-bold text-white" data-id="element-401" data-mp="3oumur602pzrl">
              {t('select_your_drink')}
            </h1>
            <p className="text-sm text-silver/70" data-id="element-402" data-mp="3tvaldqke4ela">
              {id} · {lang === 'en' ? MACHINE.location_en : MACHINE.location_am}
            </p>
          </div>
        </div>

        <div className="space-y-3" data-id="element-403" data-mp="6noxpn0f4vdl">
          {DRINKS.map(drink => <DrinkRow key={drink.id} drink={drink} data-id="element-404" data-mp="bmta0min3985" />)}
        </div>
      </section>

      {/* Sticky Review Order summary */}
      <AnimatePresence data-id="element-405" data-mp="gf36ymi699jx">
        {typeCount > 0 && <motion.div initial={{
        y: 80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 80,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-x-0 bottom-0 z-40 border-t border-[rgba(217,217,217,0.15)] bg-navy/95 backdrop-blur-md" data-id="element-406" data-mp="ldw8rho3jc49">
            <div className="mx-auto flex max-w-2xl items-center justify-between gap-4 px-4 py-4 sm:px-6" data-id="element-407" data-mp="3070ld93xencf">
              <div className="flex items-center gap-3" data-id="element-408" data-mp="2vgk5zjgjornf">
                <div className="relative" data-id="element-409" data-mp="2vezbtuy57aq3">
                  <ShoppingCartIcon className="h-7 w-7 text-neon" data-id="element-410" data-mp="3a4y8tudyog3z" />
                  <span className="absolute -right-2 -top-2 flex h-5 min-w-5 items-center justify-center rounded-full bg-neon px-1 text-xs font-bold text-white" data-id="element-411" data-mp="3a7ayktpynurl">
                    {totalQty}
                  </span>
                </div>
                <div className="text-sm" data-id="element-412" data-mp="3e6a34d7s5pii">
                  <p className="font-semibold text-white" data-id="element-413" data-mp="3e7l4659ucj5x">
                    {typeCount} {t('drink_types')} · {totalQty} {t('items')}
                  </p>
                  <p className="text-silver/70" data-id="element-414" data-mp="1jtaig5ojm54d">
                    {t('total')}:{' '}
                    <span className="font-semibold text-neon" data-id="element-415" data-mp="3vgdu2xil7zmo">{total} ETB</span>
                  </p>
                </div>
              </div>
              <Button onClick={() => navigate('/checkout/' + id)} data-id="element-416" data-mp="49b60ey1q9go">
                <span className="hidden sm:inline" data-id="element-417" data-mp="3molrf8zt1usn">
                  {t('proceed_checkout')}
                </span>
                <span className="sm:hidden" data-id="element-418" data-mp="3qocg975ru0uj">{t('continue')}</span>
                <ArrowRightIcon className="h-4 w-4" data-id="element-419" data-mp="3cpw5n54sfq74" />
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </PageShell>;
}